import { GITHUB_ACCESS_CHECK_HINT } from "../github-app"
import type { SkillSource } from "./index"

/** Wave O1 (decision 0060, wave spec §2.4): the person works on a Minga item in this session. */
export const workAnItem: SkillSource = {
  name: "work-an-item",
  title: "Work on a Minga item",
  description:
    "Work on one Minga item in this session: read it, take it for the person, do the work in the repo, open the PR with the person's own gh, and close it with evidence. Use it when the person says to work on, pick up, fix or finish a Minga item (a ref like DIC-12).",
  body: `# Work on a Minga item

## Steps

1. \`read_item\` with the ref. Read its spec, its "Done when" checks, its thread and its runs.
2. If it is assigned to a worker or an agent, or a run is working on it, stop and say so: someone is on it already.
3. Take it for the person with one \`plan\` call: an \`AssignItem\` (or \`UpdateItem\`) that makes the person its
   assignee, and, only for a leaf (an item without children), a \`MoveItem\` to \`in_progress\`. Never move a release
   or another top-level item.
4. Do the work in the repo, on a branch. Follow the project's guidelines (\`list_documents {under: "guidelines/"}\`,
   then \`read\` each that fits) for build, test, branch and PR rules, and the overview (\`read_project\`,
   \`project.overview\`) for what the project is and is not.
5. Open the pull request with the person's own \`gh\`, and \`attach\` its link to the item.
   ${GITHUB_ACCESS_CHECK_HINT}
6. When every check passes: \`close_item\` with \`as: "done"\` and evidence (the commands you ran and their results,
   the PR). If something is left, \`comment\` on the item with what is left and why.

When something you need is missing (a repo, a secret, a service, a file, a tool, a decision), say exactly what is
missing and stop. Don't mock, stub or work around it. A missing secret: name it (\`X_BEARER_TOKEN\`, what it is for)
and ask the person to add it in Project settings › Secrets in the Minga app, never to paste it into the chat.

## Never

- Take an item that a worker or an agent has.
- Close an item as done without its checks passing.
- Merge the PR unless the person asks you to.
- Paste a secret's value, customer data or personal data into Minga text (keys go into Settings › Secrets).
`,
}
